import React, { useState } from "react";
import { DeleteFilled } from "@ant-design/icons";
import { Button, Form, Input, Modal, Table, message } from "antd";
import {
  useGetCountriesQuery,
  useAddCountryMutation,
  useDeleteCountryMutation,
} from "../../../redux/Service/api";
import { ExclamationCircleFilled } from "@ant-design/icons";
import Heading from "../../../Components/Heading/Heading";
import ServerError from "../../../Components/utils/ServerError";

const { confirm } = Modal;

interface Country {
  CountryID: number;
  CountryName: string;
}

const CityCodes: React.FC = () => {
  const [openModal, setOpenModal] = useState(false);
  const [form] = Form.useForm();

  const [addCountry, { isLoading }] = useAddCountryMutation();
  const [deleteCountry, { isLoading: delIsLoading }] =
    useDeleteCountryMutation();
  const {
    data: countriesData,
    isError,
    isLoading: isCountriesLoading,
  } = useGetCountriesQuery(undefined);

  const countries: Country[] = countriesData?.ResponseObject ?? [];

  const handleAddCountry = async (values: any) => {
    try {
      await addCountry(values);
      message.success("تمت إضافة البلد بنجاح");
      form.resetFields();
      setOpenModal(false);
    } catch (error) {
      console.error("خطأ أثناء إضافة البلد:", error);
      message.error("فشل في إضافة البلد. يرجى المحاولة مرة أخرى.");
    }
  };

  const handleDeleteCountry = (id: number) => {
    confirm({
      title: "هل أنت متأكد أنك تريد حذف هذا البلد؟",
      icon: <ExclamationCircleFilled />,
      content: "بالضغط على موافق سيتم حذف البلد بشكل دائم.",
      async onOk() {
        try {
          await deleteCountry(id);
          message.success("تم حذف البلد بنجاح");
        } catch (error) {
          console.error(error);
          message.error("فشل في حذف البلد.");
        }
      },
    });
  };

  const columns = [
    {
      title: "اسم البلد",
      dataIndex: "CountryName",
      key: "CountryName",
    },
    {
      title: "الإجراءات",
      key: "actions",
      render: (_: any, country: Country) => (
        <div className="flex gap-2">
          <Button
            type="text"
            icon={<DeleteFilled />}
            danger
            onClick={() => handleDeleteCountry(country.CountryID)}
          />
        </div>
      ),
    },
  ];

  return (
    <section className="p-4 section_padding mt-0 pt-0 relative">
      <Heading heading="البلدان" />

      {isError && <ServerError />}

      <div className="text-center my-3">
        <Button
          className="w-[150px]"
          type="primary"
          onClick={() => setOpenModal(true)}
        >
          إضافة بلد
        </Button>
      </div>

      <div className="mx-auto">
        <Table
          columns={columns}
          dataSource={countries}
          rowKey="CountryID"
          loading={isCountriesLoading || delIsLoading}
          pagination={{ pageSize: 5 }}
        />
      </div>

      <Modal
        title="إضافة بلد"
        centered
        open={openModal}
        onCancel={() => {
          form.resetFields();
          setOpenModal(false);
        }}
        footer={null}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleAddCountry}
          autoComplete="off"
        >
          <Form.Item
            label="اسم البلد"
            name="CountryName"
            rules={[{ required: true, message: "يرجى إدخال اسم البلد" }]}
          >
            <Input size="large" placeholder="أدخل اسم البلد" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={isLoading} block>
              إضافة
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </section>
  );
};

export default CityCodes;
